import { render } from "./FimitSlider.vue?vue&type=template&id=3771b898&scoped=true"
import script from "./FimitSlider.vue?vue&type=script&lang=js"
export * from "./FimitSlider.vue?vue&type=script&lang=js"

import "./FimitSlider.vue?vue&type=style&index=0&id=3771b898&scoped=true&lang=css"

import exportComponent from "/home/user/Desktop/enon-projects/fimit-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3771b898"]])

export default __exports__